/**
 * Double Tap To Go
 *
 * Drop-down navigation tapping for touch based devices.
 *
 * @module dobleTapToGo
 */

;(function ($, window, document, undefined) {
    $.fn.doubleTapToGo = function (params) {
        if (
            !('ontouchstart' in window) &&
            !navigator.msMaxTouchPoints &&
            !navigator.userAgent.toLowerCase().match(/windows phone os 7/i)
        )
            return false

        this.each(function () {
            var curItem = false

            $(this).on('click', function (e) {
                var item = $(this)
                var isLevel1Menu = $(e.target).hasClass('menu-link-level-1')
                if (item[0] != curItem[0] && isLevel1Menu) {
                    e.preventDefault()
                    curItem = item
                }
            })

            $(document).on('click touchstart MSPointerDown', function (e) {
                var resetItem = true,
                    parents = $(e.target).parents()

                for (var i = 0; i < parents.length; i++) if (parents[i] == curItem[0]) resetItem = false

                if (resetItem) curItem = false
            })
        })
        return this
    }
})(jQuery, window, document)
